enum ContributionPeriod {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  HALFYEARLY = 'HALFYEARLY',
  YEARLY = 'YEARLY',
  UNDEFINED = 'UNDEFINED',
}

export default ContributionPeriod;
